import { Flex, Tag, Text } from "@chakra-ui/react"
import { tabs } from "../../../../../common/constants/search-constants"
import { useBrandedTranslation } from "../../../../../common/hooks/useBrandedTranslation"
import { Tab } from "../../../../../common/types/global"

type Props = {
  name: Tab
  count: number
  isSelected: boolean
  handleSetSelectedTab: (tab: Tab, urlParams: string) => void
  urlParams: string
}

const SearchTab = ({ name, count, isSelected, handleSetSelectedTab, urlParams }: Props) => {
  const { t } = useBrandedTranslation()

  return (
    <Flex
      align="center"
      h="12"
      py="3"
      fontWeight="medium"
      cursor={count && "pointer"}
      opacity={count ? "1" : "0.26"}
      onClick={count ? () => handleSetSelectedTab(name, urlParams) : undefined}
    >
      <Text fontSize={{ base: "sm", sm: "md" }}>
        {name === tabs.PRO ? t("plp-tab-products") : t("plp-tab-spareParts")}
      </Text>
      <Tag borderRadius="full" bgColor={isSelected && count ? "brand.500" : "gray.200"} ml="2">
        <Text color={isSelected && count ? "white" : "gray.900"} fontSize="xs">
          {count}
        </Text>
      </Tag>
    </Flex>
  )
}

export default SearchTab
